import { create } from "zustand";
import {
  DEFAULT_SERVICES_SORT_OPTION,
  ServicesSortOption,
} from "../views/services/components/sort_services_popup/sort_services_popup";

interface ServicesFilterState {
openModal: boolean;
  stateId: number | null;
  page:number,
  cityId: number | null;
  districtId: number | null;
  categoryId: number | null;
  selectedStatus: number | null;
  searchValue: string;
  startDate: string;
  endDate: string;
  ageFrom: number | null;
  ageTo: number | null;
  gender: string;
  sortOption: ServicesSortOption;
  pageSize: number;
  applyFilter: boolean;
  setField: <K extends keyof ServicesFilterState>(
    key: K,
    value: ServicesFilterState[K]
  ) => void;
  reset: () => void;
}

export const useServicesFilterStore = create<ServicesFilterState>((set) => ({
    openModal: false,
    page:1,
  stateId: null,
  cityId: null,
  districtId: null,
  categoryId: null,
  selectedStatus: null,
  searchValue: "",
  startDate: "",
  endDate: "",
  ageFrom: null,
  ageTo: null,
  gender: "",
  sortOption: DEFAULT_SERVICES_SORT_OPTION,
  pageSize: 8,
  applyFilter: false,
  setField: (key, value) =>
    set({ [key]: value } as Partial<ServicesFilterState>),
  reset: () =>
    set({
      stateId: null,
      cityId: null,
      districtId: null,
      categoryId: null,
      selectedStatus: null,
      searchValue: "",
      startDate: "",
      endDate: "",
      ageFrom: null,
      ageTo: null,
      gender: "",
      sortOption: DEFAULT_SERVICES_SORT_OPTION,
    }),
}));

export const useActiveFilterCount = () => {
  const {
    stateId,
    cityId,
    districtId,
    categoryId,
    selectedStatus,
    searchValue,
    startDate,
    endDate,
    ageFrom,
    ageTo,
    gender,
  } = useServicesFilterStore();

  let count = 0;
  if (stateId) count++;
  if (cityId) count++;
  if (districtId) count++;
  if (categoryId) count++;
  if (selectedStatus) count++;
  if (searchValue) count++;
  if (startDate) count++;
  if (endDate) count++;
  if (ageFrom !== null) count++;
  if (ageTo !== null) count++;
  if (gender) count++;
  return count;
};
